import React from "react";
import PropTypes from 'prop-types';
import MenuItem from './MenuItem';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import './DropdownMenu.scss';

const propTypes = {
    route: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    items: PropTypes.array,
    ddClasses: PropTypes.string,
};

export default class DropdownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shown: false,
        };
        this.showMenu = this.showMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    showMenu(e) {
        e.preventDefault();
        this.setState({shown: true}, () => {
            document.addEventListener('click', this.closeMenu);
        });
    }

    closeMenu() {
        this.setState({shown: false}, () => {
            document.removeEventListener('click', this.closeMenu);
        })
    }



    render() {

        const {route, label, id, items, ddClasses} = this.props;
        //console.log('shown', this.state.shown);
        //console.log('items', items);


        return(
            <div className={ddClasses}>
                <div className='dd--btns--holder'>
                    <Link to={route} id={id} className='btn btn-default btn-dropdown-prefix'>{label}</Link>
                    <button type='button' className='btn btn-default drop-down-btn' onClick={this.showMenu}>
                        <span className='dd-arrow-down'>v</span>
                    </button>
                </div>
                <div>
                {this.state.shown === true ?
                    <div className='menu--items--holder'>
                        {items.map((item, index) => (
                            <MenuItem key={index} item={item}/>
                        ))}
                    </div>:
                    <div> </div>
                }
                </div>

            </div>
        )
    }
}

DropdownMenu.propTypes = propTypes;




// WEBPACK FOOTER //
// ./src/components/DropdownMenu/index.js